import { ContentCard } from "@msuite/ui/content-card";
import { DataGrid } from "@msuite/ui/data-grid";
import { icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { Panels } from "@msuite/ui/panels";
import { formatNumber } from "@msuite/utils/numbers";
import { getArticleNumberString, getArticleSizeString } from "@msuite/utils/stock";
import { guardString } from "@msuite/utils/strings";
import { useArticle } from "@/hooks/use-article";
import type { ArticlePanelBaseProps } from "../shared";
import { ArticleStockBalanceHistory } from "./aritcle-stock-balance-history";
import { ArticleImage } from "./article-image";

export function ArticleGeneral({ articleId }: ArticlePanelBaseProps) {
	/** Hooks */
	const { t } = useTranslation();
	const { article } = useArticle(articleId);

	/** Render */
	return (
		<Panels>
			<Panels.Panel flex={1}>
				<ArticleImage articleId={articleId} />
				<ContentCard
					title={t("general.general")}
					icon={icon("Activity")}
				>
					<DataGrid>
						<DataGrid.Row>
							<DataGrid.Label>{t("general.number")}</DataGrid.Label>
							<DataGrid.Value>{getArticleNumberString(article)}</DataGrid.Value>
						</DataGrid.Row>
						<DataGrid.Row>
							<DataGrid.Label>{t("stock.article_group")}</DataGrid.Label>
							<DataGrid.Value>{guardString(article?.articleGroupName)}</DataGrid.Value>
						</DataGrid.Row>
						<DataGrid.Row>
							<DataGrid.Label>{t("stock.article_product_type")}</DataGrid.Label>
							<DataGrid.Value>{guardString(article?.articleProductTypeName)}</DataGrid.Value>
						</DataGrid.Row>
						<DataGrid.Row>
							<DataGrid.Label>{t("stock.article_size")}</DataGrid.Label>
							<DataGrid.Value>{getArticleSizeString(article)}</DataGrid.Value>
						</DataGrid.Row>
					</DataGrid>
				</ContentCard>
				<ContentCard
					title={t("stock.stock_balance")}
					icon={icon("Box")}
				>
					<DataGrid>
						<DataGrid.Row>
							<DataGrid.Label>{t("stock.stock_balance")}</DataGrid.Label>
							<DataGrid.Value>{formatNumber(article?.stockBalance, "integer", 0)}</DataGrid.Value>
						</DataGrid.Row>
						<DataGrid.Row>
							<DataGrid.Label>{t("stock.reserved_quantity")}</DataGrid.Label>
							<DataGrid.Value>
								{formatNumber(article?.reservedQuantity, "integer", 0)}
							</DataGrid.Value>
						</DataGrid.Row>
						<DataGrid.Row>
							<DataGrid.Label>{t("stock.orderable_quantity")}</DataGrid.Label>
							<DataGrid.Value>
								{formatNumber(article?.availableQuantity, "integer", 0)}
							</DataGrid.Value>
						</DataGrid.Row>
						<DataGrid.Row>
							<DataGrid.Label>{t("stock.warning_stock_balance")}</DataGrid.Label>
							<DataGrid.Value>
								{formatNumber(article?.warningStockBalance, "integer")}
							</DataGrid.Value>
						</DataGrid.Row>
						<DataGrid.Row>
							<DataGrid.Label>{t("stock.minimum_stock_balance")}</DataGrid.Label>
							<DataGrid.Value>
								{formatNumber(article?.minimumStockBalance, "integer")}
							</DataGrid.Value>
						</DataGrid.Row>
					</DataGrid>
				</ContentCard>
			</Panels.Panel>
			<Panels.Panel flex={2}>
				<ArticleStockBalanceHistory articleId={articleId} />
			</Panels.Panel>
		</Panels>
	);
}
